import { render } from "./com_periodos.vue?vue&type=template&id=76be5a4e&scoped=true"
import script from "./com_periodos.vue?vue&type=script&lang=js"
export * from "./com_periodos.vue?vue&type=script&lang=js"

import "./com_periodos.vue?vue&type=style&index=0&id=76be5a4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76be5a4e"]])

export default __exports__